var _Path, _Path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgMusicNote(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 14,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#music-note_svg__clip0_302:1523)",
    stroke: props.color,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M11.618 16.463l.701-1.829c.52-1.5 3.216-7.036-2.647-10.975a3.924 3.924 0 01-1.267-1.307A3.962 3.962 0 017.858.61",
    strokeLinecap: "round"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M7.858 20.732a3.797 3.797 0 01-1.095 2.553A3.732 3.732 0 014.23 24.39a3.611 3.611 0 01-2.564-1.072 3.674 3.674 0 01-1.063-2.586c0-.97.383-1.9 1.063-2.587a3.611 3.611 0 012.564-1.072h3.627v3.659zM7.858 18.293V0"
  }))), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "music-note_svg__clip0_302:1523"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: props.color,
    d: "M0 0h14v25H0z"
  }))));
}

export default SvgMusicNote;